import { render } from "./accordion.vue?vue&type=template&id=21576f40&scoped=true"
const script = {}

import "./accordion.vue?vue&type=style&index=0&id=21576f40&scoped=true&lang=css"

import exportComponent from "/home/runner/work/iam-atkomst-web/iam-atkomst-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21576f40"]])

export default __exports__